// components/layout/DashboardLayout.jsx
import React from 'react';
import Logo from '../common/Logo';
import PatientSidebar from '../patient/PatientSidebar';
import DoctorSidebar from '../doctor/DoctorSidebar';
import PropTypes from 'prop-types';

const DashboardLayout = ({ children, helpText }) => {
  // Funzione per ottenere il ruolo dell'utente corrente
  const getCurrentUserRole = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      return user?.role || 'patient'; // Default a patient se non trovato
    } catch (error) {
      console.error('Errore nel leggere il ruolo utente:', error);
      return 'patient'; // Fallback
    }
  };

  // Versione ULTRA-semplificata
  const renderSidebar = () => {
    const userRole = getCurrentUserRole();
    
    // Solo patient o doctor - nient'altro
    return userRole === 'patient' ? <PatientSidebar /> : <DoctorSidebar />;
  };

  return (
    <div className="flex min-h-screen">
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        {renderSidebar()}
        {helpText && (
          <div className="bottom-10 left-1/2 bg-purple-600 text-white p-4 rounded-lg shadow-lg w-10/12 mx-2.5">
            <h3 className="font-bold">Come funziona?</h3>
            <p className="text-sm">{helpText}</p>
          </div>
        )}
      </div>
      <div className="flex-1 p-8 bg-[#FAF4EB]">
        {children}
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  helpText: PropTypes.string
};

export default DashboardLayout;